import { PREFIX_API } from 'constants/api.const';
import qs from 'query-string';
import {
  CustomerFeedbackModel,
  FeedbackCriteriaStateModel,
  ListFeedbackEvaluationCriteriaRequestModel,
  ListFeedbackEvaluationCriteriaResponseModel,
} from 'models/printing-photo/customer-feedback.model';
import { baseSliceApi } from './base.slice-api';

export const feedbackApi = baseSliceApi.injectEndpoints({
  endpoints: (build) => ({
    createCustomerFeedbackApiAction: build.mutation<
      CustomerFeedbackModel,
      CustomerFeedbackModel
    >({
      query: (body) => ({
        url: `${PREFIX_API.API}/customer-feedback/create`,
        method: 'POST',
        body,
      }),
      extraOptions: { maxRetries: 1 },
    }),
    getFeedbackCriteriaApiAction: build.query<
      FeedbackCriteriaStateModel['listFeedbackCriteria'],
      ListFeedbackEvaluationCriteriaRequestModel
    >({
      query: (payload) => ({
        url: `${
          PREFIX_API.API
        }/feedback-evaluation-criteria/getlist?${qs.stringify(payload)}`,
        method: 'GET',
      }),
      transformResponse: (
        rawResult: ListFeedbackEvaluationCriteriaResponseModel,
      ) => ({
        data: rawResult?.response?.data ?? [],
        totalRecord: rawResult?.response?.totalRecord ?? 0,
      }),
      extraOptions: { maxRetries: 1 },
    }),
  }),
});

export const {
  useCreateCustomerFeedbackApiActionMutation,
  useGetFeedbackCriteriaApiActionQuery,
} = feedbackApi;

export const {
  endpoints: { createCustomerFeedbackApiAction, getFeedbackCriteriaApiAction },
} = feedbackApi;
